module.exports = __webpack_public_path__ + "img/server-qr.7a498428.jpg";